var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sections" }, [
    _vm.withExperience
      ? _c(
          "section",
          [
            _c(
              "b-row",
              { attrs: { "align-v": "center" } },
              [
                _c("b-col", { attrs: { md: "4" } }, [
                  _vm._v(_vm._s(_vm.labels.experienceLabel))
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "mt-2 mt-md-0", attrs: { md: "8" } },
                  [
                    _c("Select", {
                      attrs: { options: _vm.experienceOptions },
                      on: { input: _vm.experienceChanged },
                      model: {
                        value: _vm.experience,
                        callback: function($$v) {
                          _vm.experience = $$v
                        },
                        expression: "experience"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.withEducation
      ? _c(
          "section",
          [
            _c(
              "b-row",
              { attrs: { "align-v": "center" } },
              [
                _c("b-col", { attrs: { md: "4" } }, [
                  _vm._v("\n\t\t\t\tHast du dazu eine Schule oder Ausbildung "),
                  _c("span", { staticClass: "font-weight-extra-bold" }, [
                    _vm._v("abgeschlossen")
                  ]),
                  _vm._v("?\n\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "mt-2 mt-md-0", attrs: { md: "8" } },
                  [
                    _c("Dropdown", {
                      attrs: {
                        "characteristic-items": _vm.prepareCharacteristicItems(
                          _vm.meta.schoolType
                        ),
                        multiple: "",
                        "nothing-allowed": {
                          text: "Nein"
                        },
                        placeholder: "- Mehrfachauswahl möglich -",
                        "close-on-select": false
                      },
                      on: { input: _vm.emitChangeEvent },
                      model: {
                        value: _vm.educationsFinished,
                        callback: function($$v) {
                          _vm.educationsFinished = $$v
                        },
                        expression: "educationsFinished"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.withEducation
      ? _c(
          "section",
          [
            _c(
              "b-row",
              { attrs: { "align-v": "center" } },
              [
                _c("b-col", { attrs: { md: "4" } }, [
                  _vm._v("\n\t\t\t\tHast du dazu eine "),
                  _c("span", { staticClass: "font-weight-extra-bold" }, [
                    _vm._v("NICHT abgeschlossene")
                  ]),
                  _vm._v("\n\t\t\t\tSchule / Ausbildung?\n\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "mt-2 mt-md-0", attrs: { md: "8" } },
                  [
                    _c("Dropdown", {
                      attrs: {
                        "characteristic-items": _vm.prepareCharacteristicItems(
                          _vm.meta.schoolType
                        ),
                        "nothing-allowed": {
                          text: "Nein"
                        },
                        placeholder: "- Mehrfachauswahl möglich -",
                        multiple: "",
                        "close-on-select": false
                      },
                      on: { input: _vm.emitChangeEvent },
                      model: {
                        value: _vm.educationsUnfinished,
                        callback: function($$v) {
                          _vm.educationsUnfinished = $$v
                        },
                        expression: "educationsUnfinished"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.withSelfAssessment
      ? _c(
          "section",
          [
            _c(
              "b-row",
              { attrs: { "align-v": "center" } },
              [
                _c("b-col", { attrs: { md: "4" } }, [
                  _vm._v(_vm._s(_vm.labels.selfAssessmentLabel))
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "mt-2 mt-md-0", attrs: { md: "8" } },
                  [
                    _c("Select", {
                      attrs: { options: _vm.selfAssessmentOptions },
                      on: { input: _vm.selfAssessmentChanged },
                      model: {
                        value: _vm.selfAssessment,
                        callback: function($$v) {
                          _vm.selfAssessment = $$v
                        },
                        expression: "selfAssessment"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }